import React from 'react';
import styled from '@emotion/styled';

import { Theme } from 'ui_system/theme';

const Container = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80px;
  padding: 9px;
  background-color: ${(props) =>
    props.headerColor ? props.headerColor : '#FFFFFF'};

  /* Centered + cropped header settings */
  border-left: ${(props) =>
    props.nonFullWidth ? `1px solid ${Theme.colors.lightLine};` : 'none'};
  border-right: ${(props) =>
    props.nonFullWidth ? `1px solid ${Theme.colors.lightLine};` : 'none'};
  border-bottom: ${(props) =>
    props.borderBottom ? `1px solid ${Theme.colors.lightLine};` : 'none'};
  max-width: ${(props) =>
    props.nonFullWidth ? `${Theme.mobile.phoneWidth}px` : 'unset'};
  margin: ${(props) => (props.nonFullWidth ? '0 auto' : 'unset')};
`;

const Logo = styled('img')`
  width: auto;
  height: 100%;
  max-height: 60px;
  max-width: 100%;
`;

const Header = ({
  name,
  logo,
  headerColor,
  className,
  nonFullWidth,
  borderBottom,
}) => (
  <Container
    headerColor={headerColor}
    className={className}
    nonFullWidth={nonFullWidth}
    borderBottom={borderBottom}
  >
    {logo ? <Logo src={logo} /> : name}
  </Container>
);

export default Header;
